"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ServiceProviderConfig_1 = __importDefault(require("./ServiceProviderConfig"));
const ResourceTypes_1 = __importDefault(require("./ResourceTypes"));
const Schemas_1 = __importDefault(require("./Schemas"));
const Users_1 = __importDefault(require("./Users"));
class Index {
    constructor(rc, version = 'v2') {
        this.rc = rc;
        this.version = version;
    }
    path(withParameter = true) {
        if (withParameter && this.version !== null) {
            return `/scim/${this.version}`;
        }
        return '/scim';
    }
    users(scimUserId = null) {
        return new Users_1.default(this, scimUserId);
    }
    schemas(uri = null) {
        return new Schemas_1.default(this, uri);
    }
    resourceTypes(type = null) {
        return new ResourceTypes_1.default(this, type);
    }
    serviceProviderConfig() {
        return new ServiceProviderConfig_1.default(this);
    }
}
exports.default = Index;
//# sourceMappingURL=index.js.map